import Vuex from "vuex";
import client from "./modules/client/client";
import payment from "./modules/payment/payment";

export default new Vuex.Store({
  modules: {
    client,
    payment,
  },
  state: {
    language: "en",
    isMenuOpened: false,
    brandName: "",
    brandTitle: "",
    emailDomain: "",
    history: [],
    forbidden: false,
    registering: true,
  },
  getters: {
    language: (state) => {
      return state.language;
    },
    isMenuOpened: (state) => {
      return state.isMenuOpened;
    },
    brandName: (state) => {
      return state.brandName;
    },
    brandTitle: (state) => {
      return state.brandTitle;
    },
    emailDomain: (state) => {
      return state.emailDomain;
    },
    history: (state) => {
      return state.history;
    },
  },
  mutations: {
    setLanguage(state, language) {
      state.language = language;
    },
    setMenuOpened(state, isMenuOpened) {
      state.isMenuOpened = isMenuOpened;
    },
    setBrandName(state, brandName) {
      state.brandName = brandName;
    },
    setBrandTitle(state, brandTitle) {
      state.brandTitle = brandTitle;
    },
    setEmailDomain(state, emailDomain) {
      state.emailDomain = emailDomain;
    },
    addHistory(state, newPath) {
      state.history.push(newPath);
    },
    setHistory(state, history) {
      state.history = history;
    },
    setForbidden(state, payload) {
      state.forbidden = payload;
    },
    setRegistering(state, payload) {
      state.registering = payload;
    },
  },
  actions: {
    setLanguage({ commit }, payload) {
      commit("setLanguage", payload);
    },
    setMenuOpened({ commit }, payload) {
      commit("setMenuOpened", payload);
    },
    addHistory({ commit }, newPath) {
      commit("addHistory", newPath);
    },
    setHistory({ commit }, historyNew) {
      commit("setHistory", historyNew);
    },
    setForbidden({ commit }, payload) {
      commit("setForbidden", payload);
    },
    setRegistering({ commit }, payload) {
      commit("setRegistering", payload);
    },
  },
});
